import React from "react";

import Column from "./Column";

class Columns extends React.Component {
  render() {
    const columns = this.props.columns || [];
    const keys = Object.keys(columns);

    return keys.map((key) => {
      const column = { ...columns[key], key };
      return <Column key={key} column={column} {...this.props} />;
    });
  }
}

export default Columns;
